"use client";

import type { PipelineCandidate } from "@/lib/api/types";
import { Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip";
import { EmptyCell } from "@/features/candidate";
import { formatExactDateTime, formatRelativeDate } from "../utils";

export function AddedAtCell({ candidate }: { candidate: PipelineCandidate }) {
  if (!candidate.added_at) {
    return <EmptyCell />;
  }
  const exact = formatExactDateTime(candidate.added_at);
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="cursor-default whitespace-nowrap text-sm text-muted-foreground">
          {formatRelativeDate(candidate.added_at)}
        </span>
      </TooltipTrigger>
      <TooltipContent side="top">{exact}</TooltipContent>
    </Tooltip>
  );
}
